// Multilingual translations for Caireen Verein (HU / DE / EN)
export const translations = {
    hu: {
        meta: { lang: "Magyar", code: "HU" },
        nav: {
            home: "Kezdőlap",
            about: "Rólunk",
            projects: "Projektek",
            news: "Hírek & Események",
            donate: "Adományozás",
            contact: "Kapcsolat",
            join: "Csatlakozz",
            donateCta: "Adományozz most",
        },
        hero: {
            eyebrow: "Caireen Egyesület · Caireen e.V.",
            title: "Tudás, gondoskodás,",
            titleAccent: "esélyegyenlőség.",
            sub: "Nemzetközi hálózatot építünk, amely egészséget, oktatást, kutatást, kultúrát és társadalmi befogadást köt össze – Ausztriától Magyarországig, Európán át a világba.",
            ctaDonate: "Adományozz most",
            ctaJoin: "Csatlakozz hozzánk",
            stat1: "fókuszterület",
            stat2: "ország",
            stat3: "alapérték",
            badge: "Bejegyezve Ausztriában · ZVR 1121813363",
        },
        mission: {
            eyebrow: "A küldetésünk",
            title: "Hidakat építünk emberek, kultúrák és lehetőségek között.",
            body:
                "A Caireen Verein gazdasági haszonszerzésre nem törekvő, közhasznú egyesület. Olyan minőségi nemzetközi hálózatot építünk és működtetünk, amely a tudást, az innovációt, a társadalmi felelősséget, az egészséget, az oktatást, a kutatást és a kultúrát egyetlen közösségben kapcsolja össze.",
        },
        nameMeaning: {
            eyebrow: "A név mögött",
            title: "A Caireen név jelentése",
            p1: "A Caireen név egy kelta ihletésű női alakhoz kapcsolódik, akit egyes hagyományok védelmező, gondoskodó szereplőként említenek. A névhez társított jelentésvilágban megjelenik az oltalom, az emberi méltóság védelme, a kiszolgáltatottak támogatása és a biztonság megteremtése.",
            p2: "Számunkra a Caireen név ezt az értékrendet fejezi ki: figyelmet, gondoskodást és felelősséget azok iránt, akik támogatásra, védelemre vagy megbízható segítségre szorulnak.",
            p3: "A Caireen ezért nem csupán egy név, hanem egy szemlélet: emberközpontú, védelmező és biztonságot teremtő hozzáállás.",
            badges: ["Oltalom", "Méltóság", "Gondoskodás", "Biztonság"],
        },
        focusTitle: "Fókuszterületeink",
        focusSub: "Hét terület – egyetlen közös cél: hogy minden ember megtalálja a helyét és a hangját.",
        focus: [
            { t: "Egészség & Rehabilitáció", d: "Egészségügyi innováció, prevenció, rehabilitáció és társadalmi újítások a gyógyulás szolgálatában.", c: "olive" },
            { t: "Oktatás & Tudástranszfer", d: "Képzések, ösztöndíjak, szakmai fejlődés és nemzetközi együttműködés.", c: "yellow" },
            { t: "Kutatás & Fejlesztés", d: "Kutatási, fejlesztési és innovációs programok támogatása EU-s partnerekkel.", c: "blue" },
            { t: "Társadalmi Befogadás", d: "Esélyegyenlőség, fogyatékkal élők és hátrányos helyzetűek integrációja.", c: "orange" },
            { t: "Munka & Foglalkoztatás", d: "Munkaerő-piaci, kvalifikációs és foglalkoztatási programok támogatása.", c: "red" },
            { t: "Művészet & Kultúra", d: "Közösségépítő, művészeti és kulturális programok – mindenki számára nyitva.", c: "yellow" },
            { t: "Nemzetközi Együttműködés", d: "Stratégiai partnerségek alapítványokkal, szervezetekkel, intézményekkel.", c: "blue" },
        ],
        statsTitle: "Hatás, amit közösen érünk el",
        stats: [
            { v: 7, l: "Fókuszterület" },
            { v: 8, l: "Ország" },
            { v: 24, l: "Partner" },
            { v: 100, l: "Önkéntes lehetőség" },
        ],
        opportunities: {
            title: "Lehetőségek, amelyek életeket változtatnak",
            sub: "Programjaink új perspektívát adnak az embereknek – legyen szó tanulásról, munkáról, művészetről vagy gyógyulásról.",
            items: [
                "Ösztöndíjak, mentorprogramok és szakmai gyakorlat",
                "Rehabilitációs és prevenciós programok",
                "Művészi és kulturális kibontakozási platform",
                "Nemzetközi konferenciák, workshopok, képzések",
                "Családtámogatási szolgáltatások",
                "Önkéntes és közösségi részvétel",
            ],
            cta: "Fedezd fel a lehetőségeket",
        },
        projectsPage: {
            title: "Projektjeink",
            sub: "Konkrét kezdeményezések, amelyek a Caireen Verein értékeit életre keltik.",
            readMore: "Tudj meg többet",
            filter: { all: "Összes", health: "Egészség", education: "Oktatás", research: "Kutatás", social: "Társadalmi", culture: "Kultúra", employment: "Munka" },
        },
        newsPage: {
            title: "Hírek & Események",
            sub: "Friss hírek a Caireen Verein életéből, eseményekről, eredményekről.",
            readMore: "Olvasd el",
        },
        donatePage: {
            eyebrow: "Adományozz · Ajándékozz · Támogass",
            title: "Adományod azonnal cselekvéssé válik.",
            sub: "Akár egyszeri adományt küldesz, akár szeretteid nevére ajándékozol egy összeget – minden hozzájárulás közvetlenül a projektjeinkbe fordul.",
            amountTitle: "Válassz egy összeget",
            customAmount: "Egyedi összeg (€)",
            frequency: { once: "Egyszeri", monthly: "Havi", yearly: "Éves" },
            typeRegular: "Saját nevemben adományozok",
            typeGift: "Ajándék adomány másvalaki nevére",
            donorName: "Teljes név",
            donorEmail: "E-mail",
            recipientName: "Ajándékozott neve",
            recipientEmail: "Ajándékozott e-mail (opcionális)",
            giftMessage: "Üzenet az ajándékozottnak",
            area: "Melyik területet támogatod?",
            areas: {
                general: "Általános támogatás",
                health: "Egészség & Rehabilitáció",
                education: "Oktatás",
                culture: "Művészet & Kultúra",
                social: "Társadalmi Befogadás",
            },
            submit: "Adományozás megerősítése",
            bankTitle: "Banki átutalás",
            bankSub: "Ha közvetlenül banki úton szeretnél utalni, az alábbi adatokat használhatod:",
            iban: "AT69 4300 0455 0011 0007",
            bic: "—",
            holder: "Caireen Verein",
            success: "Köszönjük szépen az adományodat! Hamarosan visszaigazoló e-mailt küldünk.",
            error: "Nem sikerült rögzíteni az adományt. Kérjük, próbáld újra.",
        },
        contactPage: {
            title: "Lépj kapcsolatba velünk",
            sub: "Kérdésed van? Együttműködési ajánlatod? Írj nekünk – szívesen válaszolunk magyarul, németül vagy angolul.",
            name: "Neved",
            email: "E-mail címed",
            subject: "Tárgy",
            message: "Üzeneted",
            submit: "Üzenet küldése",
            success: "Köszönjük az üzeneted, hamarosan jelentkezünk.",
            error: "Hiba történt. Kérjük, próbáld újra.",
            address: "Cím",
            zvr: "ZVR-szám",
            org: "Szervezet",
        },
        aboutPage: {
            title: "A Caireen Verein-ről",
            sub: "Egy közhasznú egyesület Ausztriában, amely világszerte épít hidakat tudás és gondoskodás között.",
            valuesTitle: "Értékeink",
            values: [
                { t: "Emberközpontúság", d: "Minden program középpontjában a méltóság és az ember áll." },
                { t: "Átláthatóság", d: "Tiszta, közhasznú működés és felelős eszközhasználat." },
                { t: "Befogadás", d: "Diszkrimináció-mentesség és esélyegyenlőség minden szinten." },
                { t: "Együttműködés", d: "Stratégiai partnerségek – határokon és szektorokon át." },
            ],
            structureTitle: "Szervezeti felépítés",
            structure: [
                { t: "Közgyűlés (Generalversammlung)", d: "A legmagasabb döntéshozó szerv. Évente legalább egyszer ülésezik." },
                { t: "Elnökség (Vorstand)", d: "Az egyesület operatív vezetése, élén az elnökkel és alelnökkel." },
                { t: "Számvizsgálók", d: "Két, közgyűlés által választott független számvizsgáló." },
                { t: "Választott bíróság", d: "Belső jogviták rendezésére." },
            ],
            joinTitle: "Csatlakozz tagként",
            joinSub: "Töltsd ki a jelentkezési űrlapot és lépj be a Caireen Verein nemzetközi közösségébe.",
            fullName: "Teljes név",
            phone: "Telefon",
            country: "Ország",
            motivation: "Miért szeretnél csatlakozni?",
            memberType: "Tagság típusa",
            memberTypes: { ordinary: "Rendes tag", extraordinary: "Rendkívüli tag", supporting: "Támogató tag" },
            submitJoin: "Jelentkezés elküldése",
            joinSuccess: "Köszönjük a jelentkezésed! Az elnökség hamarosan visszajelez.",
            joinError: "Nem sikerült elküldeni a jelentkezést.",
        },
        newsletter: {
            title: "Maradj velünk",
            sub: "Iratkozz fel a havi hírlevelünkre – események, projektek, lehetőségek.",
            email: "E-mail címed",
            submit: "Feliratkozás",
            success: "Köszönjük! Sikeresen feliratkoztál.",
            error: "A feliratkozás nem sikerült.",
        },
        footer: {
            tagline: "Tudás. Gondoskodás. Esélyegyenlőség.",
            legal: "© {year} Caireen Verein. Minden jog fenntartva.",
            quickLinks: "Gyors linkek",
            contactInfo: "Elérhetőség",
            languages: "Nyelvek",
            address: "Innerteuchen 26, 9543 Arriach, Ausztria",
            impressum: "Impresszum",
        },
    },

    de: {
        meta: { lang: "Deutsch", code: "DE" },
        nav: {
            home: "Startseite",
            about: "Über uns",
            projects: "Projekte",
            news: "News & Termine",
            donate: "Spenden",
            contact: "Kontakt",
            join: "Mitglied werden",
            donateCta: "Jetzt spenden",
        },
        hero: {
            eyebrow: "Caireen Verein · Caireen Egyesület",
            title: "Wissen, Fürsorge,",
            titleAccent: "Chancengleichheit.",
            sub: "Wir bauen ein internationales Netzwerk auf, das Gesundheit, Bildung, Forschung, Kultur und soziale Integration verbindet – von Österreich über Ungarn und Europa hinaus in die Welt.",
            ctaDonate: "Jetzt spenden",
            ctaJoin: "Mitglied werden",
            stat1: "Fokusbereiche",
            stat2: "Länder",
            stat3: "Grundwerte",
            badge: "Eingetragen in Österreich · ZVR 1121813363",
        },
        mission: {
            eyebrow: "Unsere Mission",
            title: "Wir bauen Brücken zwischen Menschen, Kulturen und Möglichkeiten.",
            body:
                "Der Caireen Verein ist ein gemeinnütziger Verein. Wir bauen ein qualitativ hochwertiges internationales Netzwerk auf, das Wissen, Innovation, gesellschaftliche Verantwortung, Gesundheit, Bildung, Forschung und Kultur in einer Gemeinschaft verbindet.",
        },
        nameMeaning: {
            eyebrow: "Hinter dem Namen",
            title: "Die Bedeutung des Namens Caireen",
            p1: "Der Name Caireen geht auf eine keltisch inspirierte weibliche Gestalt zurück, die in manchen Überlieferungen als schützende, fürsorgliche Figur erwähnt wird. Die mit dem Namen verbundene Bedeutungswelt umfasst Schutz, die Wahrung der Menschenwürde, die Unterstützung der Schwächeren und die Schaffung von Sicherheit.",
            p2: "Für uns drückt der Name Caireen genau diese Werte aus: Aufmerksamkeit, Fürsorge und Verantwortung für jene, die Unterstützung, Schutz oder verlässliche Hilfe brauchen.",
            p3: "Caireen ist daher nicht nur ein Name, sondern eine Haltung: menschenzentriert, schützend und Sicherheit gebend.",
            badges: ["Schutz", "Würde", "Fürsorge", "Sicherheit"],
        },
        focusTitle: "Unsere Schwerpunkte",
        focusSub: "Sieben Bereiche – ein gemeinsames Ziel: dass jeder Mensch seinen Platz und seine Stimme findet.",
        focus: [
            { t: "Gesundheit & Rehabilitation", d: "Gesundheitsinnovation, Prävention, Rehabilitation und soziale Innovationen für Heilung und Wohlbefinden.", c: "olive" },
            { t: "Bildung & Wissenstransfer", d: "Fortbildung, Stipendien, berufliche Entwicklung und internationale Fachkooperation.", c: "yellow" },
            { t: "Forschung & Entwicklung", d: "Forschung, Entwicklung und Innovationsprogramme mit EU-Partnern.", c: "blue" },
            { t: "Soziale Integration", d: "Chancengleichheit, Integration von Menschen mit Behinderungen und sozial Benachteiligten.", c: "orange" },
            { t: "Arbeit & Beschäftigung", d: "Arbeitsmarkt-, Qualifizierungs- und Beschäftigungsprogramme.", c: "red" },
            { t: "Kunst & Kultur", d: "Gemeinschaftsbildende, künstlerische und kulturelle Formate – offen für alle.", c: "yellow" },
            { t: "Internationale Kooperation", d: "Strategische Partnerschaften mit Stiftungen, Organisationen und Institutionen.", c: "blue" },
        ],
        statsTitle: "Wirkung, die wir gemeinsam erreichen",
        stats: [
            { v: 7, l: "Schwerpunkte" },
            { v: 8, l: "Länder" },
            { v: 24, l: "Partner" },
            { v: 100, l: "Engagement-Möglichkeiten" },
        ],
        opportunities: {
            title: "Möglichkeiten, die Leben verändern",
            sub: "Unsere Programme eröffnen neue Perspektiven – sei es in Bildung, Beruf, Kunst oder Genesung.",
            items: [
                "Stipendien, Mentoring und Praktika",
                "Rehabilitations- und Präventionsprogramme",
                "Bühne für Kunst und Kultur",
                "Internationale Konferenzen, Workshops und Schulungen",
                "Familienunterstützungsangebote",
                "Ehrenamt und Gemeinschaftsbeteiligung",
            ],
            cta: "Möglichkeiten entdecken",
        },
        projectsPage: {
            title: "Unsere Projekte",
            sub: "Konkrete Initiativen, die die Werte des Caireen Verein zum Leben erwecken.",
            readMore: "Mehr erfahren",
            filter: { all: "Alle", health: "Gesundheit", education: "Bildung", research: "Forschung", social: "Soziales", culture: "Kultur", employment: "Arbeit" },
        },
        newsPage: {
            title: "News & Termine",
            sub: "Aktuelles aus dem Caireen Verein: Veranstaltungen, Ergebnisse, Geschichten.",
            readMore: "Weiterlesen",
        },
        donatePage: {
            eyebrow: "Spenden · Verschenken · Unterstützen",
            title: "Deine Spende wird sofort zu Wirkung.",
            sub: "Ob einmalig oder als Geschenk im Namen eines geliebten Menschen – jede Spende fließt direkt in unsere Projekte.",
            amountTitle: "Wähle einen Betrag",
            customAmount: "Eigener Betrag (€)",
            frequency: { once: "Einmalig", monthly: "Monatlich", yearly: "Jährlich" },
            typeRegular: "Ich spende in meinem Namen",
            typeGift: "Geschenkspende im Namen einer anderen Person",
            donorName: "Vollständiger Name",
            donorEmail: "E-Mail",
            recipientName: "Name der beschenkten Person",
            recipientEmail: "E-Mail der beschenkten Person (optional)",
            giftMessage: "Nachricht an die beschenkte Person",
            area: "Welchen Bereich möchtest du unterstützen?",
            areas: {
                general: "Allgemeine Unterstützung",
                health: "Gesundheit & Rehabilitation",
                education: "Bildung",
                culture: "Kunst & Kultur",
                social: "Soziale Integration",
            },
            submit: "Spende bestätigen",
            bankTitle: "Banküberweisung",
            bankSub: "Wenn du direkt per Bank überweisen möchtest, verwende bitte die folgenden Daten:",
            iban: "AT69 4300 0455 0011 0007",
            bic: "—",
            holder: "Caireen Verein",
            success: "Vielen Dank für deine Spende! Du erhältst in Kürze eine Bestätigung per E-Mail.",
            error: "Spende konnte nicht erfasst werden. Bitte versuche es erneut.",
        },
        contactPage: {
            title: "Kontakt aufnehmen",
            sub: "Hast du eine Frage oder einen Kooperationsvorschlag? Schreib uns – gerne auf Deutsch, Ungarisch oder Englisch.",
            name: "Dein Name",
            email: "Deine E-Mail",
            subject: "Betreff",
            message: "Deine Nachricht",
            submit: "Nachricht senden",
            success: "Vielen Dank für deine Nachricht. Wir melden uns bald.",
            error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
            address: "Adresse",
            zvr: "ZVR-Zahl",
            org: "Organisation",
        },
        aboutPage: {
            title: "Über den Caireen Verein",
            sub: "Ein gemeinnütziger Verein in Österreich, der weltweit Brücken zwischen Wissen und Fürsorge baut.",
            valuesTitle: "Unsere Werte",
            values: [
                { t: "Menschlichkeit", d: "Würde und der Mensch stehen im Mittelpunkt jedes Programms." },
                { t: "Transparenz", d: "Klare, gemeinnützige Arbeit und verantwortungsvoller Umgang mit Mitteln." },
                { t: "Inklusion", d: "Diskriminierungsfreiheit und Chancengleichheit auf allen Ebenen." },
                { t: "Kooperation", d: "Strategische Partnerschaften – über Grenzen und Sektoren hinweg." },
            ],
            structureTitle: "Organe des Vereins",
            structure: [
                { t: "Generalversammlung", d: "Höchstes Beschlussorgan, tagt mindestens einmal jährlich." },
                { t: "Vorstand", d: "Operative Leitung mit Präsident und Vizepräsident." },
                { t: "Rechnungsprüfer", d: "Zwei unabhängige, von der Generalversammlung gewählte Prüfer:innen." },
                { t: "Schiedsgericht", d: "Zur internen Beilegung von Vereins-Streitigkeiten." },
            ],
            joinTitle: "Werde Mitglied",
            joinSub: "Fülle das Formular aus und tritt der internationalen Caireen-Gemeinschaft bei.",
            fullName: "Vollständiger Name",
            phone: "Telefon",
            country: "Land",
            motivation: "Warum möchtest du beitreten?",
            memberType: "Art der Mitgliedschaft",
            memberTypes: { ordinary: "Ordentliches Mitglied", extraordinary: "Außerordentliches Mitglied", supporting: "Förderndes Mitglied" },
            submitJoin: "Antrag einreichen",
            joinSuccess: "Danke für deinen Antrag! Der Vorstand meldet sich in Kürze.",
            joinError: "Der Antrag konnte nicht gesendet werden.",
        },
        newsletter: {
            title: "Bleib in Kontakt",
            sub: "Abonniere unseren monatlichen Newsletter – Veranstaltungen, Projekte, Möglichkeiten.",
            email: "Deine E-Mail",
            submit: "Abonnieren",
            success: "Danke! Du bist jetzt abonniert.",
            error: "Abonnement fehlgeschlagen.",
        },
        footer: {
            tagline: "Wissen. Fürsorge. Chancengleichheit.",
            legal: "© {year} Caireen Verein. Alle Rechte vorbehalten.",
            quickLinks: "Schnellzugriff",
            contactInfo: "Kontakt",
            languages: "Sprachen",
            address: "Innerteuchen 26, 9543 Arriach, Österreich",
            impressum: "Impressum",
        },
    },

    en: {
        meta: { lang: "English", code: "EN" },
        nav: {
            home: "Home",
            about: "About",
            projects: "Projects",
            news: "News & Events",
            donate: "Donate",
            contact: "Contact",
            join: "Become a member",
            donateCta: "Donate now",
        },
        hero: {
            eyebrow: "Caireen Verein · Caireen Egyesület",
            title: "Knowledge, care,",
            titleAccent: "equal opportunity.",
            sub: "We build an international network that connects health, education, research, culture and social inclusion – from Austria across Hungary and Europe to the whole world.",
            ctaDonate: "Donate now",
            ctaJoin: "Become a member",
            stat1: "focus areas",
            stat2: "countries",
            stat3: "core values",
            badge: "Registered in Austria · ZVR 1121813363",
        },
        mission: {
            eyebrow: "Our mission",
            title: "We build bridges between people, cultures and opportunities.",
            body:
                "Caireen Verein is a non-profit association. We build and run a high-quality international network that connects knowledge, innovation, social responsibility, health, education, research and culture in a single community.",
        },
        nameMeaning: {
            eyebrow: "Behind the name",
            title: "The meaning of the name Caireen",
            p1: "The name Caireen is linked to a Celtic-inspired female figure who, in some traditions, is described as a protective, caring presence. The world of meaning around the name embraces shelter, the safeguarding of human dignity, support for the vulnerable and the creation of security.",
            p2: "For us, the name Caireen embodies exactly these values: attention, care and responsibility towards those who need support, protection or dependable help.",
            p3: "Caireen is therefore not just a name but an attitude: human-centred, protective and bringing safety.",
            badges: ["Shelter", "Dignity", "Care", "Safety"],
        },
        focusTitle: "Our focus areas",
        focusSub: "Seven areas – one shared goal: that every person finds their place and their voice.",
        focus: [
            { t: "Health & Rehabilitation", d: "Health innovation, prevention, rehabilitation and social innovation for healing and wellbeing.", c: "olive" },
            { t: "Education & Knowledge", d: "Training, scholarships, professional development and international cooperation.", c: "yellow" },
            { t: "Research & Development", d: "R&D and innovation programmes together with EU partners.", c: "blue" },
            { t: "Social Inclusion", d: "Equal opportunity and inclusion of people with disabilities and the disadvantaged.", c: "orange" },
            { t: "Work & Employment", d: "Labour-market, qualification and employment integration programmes.", c: "red" },
            { t: "Art & Culture", d: "Community-building, artistic and cultural formats – open to all.", c: "yellow" },
            { t: "International Cooperation", d: "Strategic partnerships with foundations, organisations and institutions.", c: "blue" },
        ],
        statsTitle: "Impact we create together",
        stats: [
            { v: 7, l: "Focus areas" },
            { v: 8, l: "Countries" },
            { v: 24, l: "Partners" },
            { v: 100, l: "Ways to engage" },
        ],
        opportunities: {
            title: "Opportunities that change lives",
            sub: "Our programmes open new perspectives – in learning, work, art or recovery.",
            items: [
                "Scholarships, mentoring and internships",
                "Rehabilitation and prevention programmes",
                "A stage for art and culture",
                "International conferences, workshops and trainings",
                "Family support services",
                "Volunteering and community engagement",
            ],
            cta: "Discover opportunities",
        },
        projectsPage: {
            title: "Our projects",
            sub: "Concrete initiatives that bring the values of Caireen Verein to life.",
            readMore: "Read more",
            filter: { all: "All", health: "Health", education: "Education", research: "Research", social: "Social", culture: "Culture", employment: "Work" },
        },
        newsPage: {
            title: "News & Events",
            sub: "What's new at Caireen Verein – events, results, stories.",
            readMore: "Read more",
        },
        donatePage: {
            eyebrow: "Donate · Gift · Support",
            title: "Your donation turns into action instantly.",
            sub: "Whether one-time or as a gift in someone's name – every contribution goes directly to our projects.",
            amountTitle: "Choose an amount",
            customAmount: "Custom amount (€)",
            frequency: { once: "One-time", monthly: "Monthly", yearly: "Yearly" },
            typeRegular: "I donate in my own name",
            typeGift: "Gift donation in someone else's name",
            donorName: "Full name",
            donorEmail: "Email",
            recipientName: "Recipient's name",
            recipientEmail: "Recipient's email (optional)",
            giftMessage: "Message to the recipient",
            area: "Which area would you like to support?",
            areas: {
                general: "General support",
                health: "Health & Rehabilitation",
                education: "Education",
                culture: "Art & Culture",
                social: "Social Inclusion",
            },
            submit: "Confirm donation",
            bankTitle: "Bank transfer",
            bankSub: "If you prefer to donate directly via bank transfer, please use the details below:",
            iban: "AT69 4300 0455 0011 0007",
            bic: "—",
            holder: "Caireen Verein",
            success: "Thank you for your donation! You'll receive a confirmation email shortly.",
            error: "We couldn't record your donation. Please try again.",
        },
        contactPage: {
            title: "Get in touch",
            sub: "Have a question or a partnership idea? Write to us – in English, German or Hungarian.",
            name: "Your name",
            email: "Your email",
            subject: "Subject",
            message: "Your message",
            submit: "Send message",
            success: "Thank you for your message – we'll be in touch shortly.",
            error: "Something went wrong. Please try again.",
            address: "Address",
            zvr: "ZVR number",
            org: "Organisation",
        },
        aboutPage: {
            title: "About Caireen Verein",
            sub: "An Austrian non-profit association building bridges between knowledge and care worldwide.",
            valuesTitle: "Our values",
            values: [
                { t: "Human-centred", d: "Dignity and people are at the heart of every programme." },
                { t: "Transparency", d: "Clear, non-profit operations and responsible use of resources." },
                { t: "Inclusion", d: "Non-discrimination and equal opportunity at every level." },
                { t: "Cooperation", d: "Strategic partnerships – across borders and sectors." },
            ],
            structureTitle: "Organisation",
            structure: [
                { t: "General Assembly", d: "Highest decision-making body. Meets at least once a year." },
                { t: "Board", d: "Operative leadership led by the President and Vice-President." },
                { t: "Auditors", d: "Two independent auditors elected by the General Assembly." },
                { t: "Arbitration Tribunal", d: "Resolves internal association disputes." },
            ],
            joinTitle: "Become a member",
            joinSub: "Fill in the form and join the Caireen Verein international community.",
            fullName: "Full name",
            phone: "Phone",
            country: "Country",
            motivation: "Why do you want to join?",
            memberType: "Type of membership",
            memberTypes: { ordinary: "Ordinary member", extraordinary: "Extraordinary member", supporting: "Supporting member" },
            submitJoin: "Submit application",
            joinSuccess: "Thank you for applying! The Board will get back to you soon.",
            joinError: "We couldn't send your application.",
        },
        newsletter: {
            title: "Stay in touch",
            sub: "Subscribe to our monthly newsletter – events, projects, opportunities.",
            email: "Your email",
            submit: "Subscribe",
            success: "Thank you! You're now subscribed.",
            error: "Subscription failed.",
        },
        footer: {
            tagline: "Knowledge. Care. Equal opportunity.",
            legal: "© {year} Caireen Verein. All rights reserved.",
            quickLinks: "Quick links",
            contactInfo: "Contact",
            languages: "Languages",
            address: "Innerteuchen 26, 9543 Arriach, Austria",
            impressum: "Legal notice",
        },
    },
};

export const supportedLanguages = ["hu", "de", "en"];
